import firebase from "@firebase/app";
import "@firebase/firestore";
import { initFirestorter, Collection } from "firestorter";

let config = {};
if (
  window.location.hostname === "ahd.pdbit.nl" ||
  window.location.hostname.startsWith("localhost") ||
  window.location.hostname.startsWith("imac")
) {
  config = {
    apiKey: "AIzaSyBK26vpJZhQqa5Ff7x8qHB-PWlNDgOi61U",
    authDomain: "ahdwebapp-1961.firebaseapp.com",
    databaseURL: "https://ahdwebapp-1961.firebaseio.com",
    projectId: "ahdwebapp-1961",
    storageBucket: "ahdwebapp-1961.appspot.com",
    messagingSenderId: "32090558857"
  };
} else {
  config = {
    apiKey: "AIzaSyCydzx2pTCJOi3-GU4gTRIAWB9bu-Uq70U",
    authDomain: "developahdwebapp.firebaseapp.com",
    databaseURL: "https://developahdwebapp.firebaseio.com",
    projectId: "developahdwebapp",
    storageBucket: "developahdwebapp.appspot.com",
    messagingSenderId: "815443171725"
  };
}
// const config = {
//   apiKey: "AIzaSyBK26vpJZhQqa5Ff7x8qHB-PWlNDgOi61U",
//   authDomain: "ahdwebapp-1961.firebaseapp.com",
//   databaseURL: "https://ahdwebapp-1961.firebaseio.com",
//   projectId: "ahdwebapp-1961",
//   storageBucket: "ahdwebapp-1961.appspot.com",
//   messagingSenderId: "32090558857"
// };

// const config = {
//   apiKey: "AIzaSyCydzx2pTCJOi3-GU4gTRIAWB9bu-Uq70U",
//   authDomain: "developahdwebapp.firebaseapp.com",
//   databaseURL: "https://developahdwebapp.firebaseio.com",
//   projectId: "developahdwebapp",
//   storageBucket: "developahdwebapp.appspot.com",
//   messagingSenderId: "815443171725"
// };

firebase.initializeApp(config);
let firestore;
firestore = firebase.firestore();
firestore.settings({ timestampsInSnapshots: true });
initFirestorter({ firebase: firebase });
const vrijwilligers = new Collection("vrijwilligers");
const klanten = new Collection("klanten");
const opdrachten = new Collection("opdrachten");

//const gebruikers = new Collection("gebruikers");

export { firebase, vrijwilligers, klanten, opdrachten };

//https://firebase.google.com/docs/firestore/solutions/arrays

// // Sample document in the 'posts' collection
// {
//   title: "My great post",
//   categories: {
//       "technology": true,
//       "opinion": true,
//       "cats": true
//   }
// }

// Now it's easy to query for all blog posts within a single category:

// WEB
// // Find all documents in the 'posts' collection that are
// // in the 'cats' category.
// db.collection('posts')
//   .where('categories.cats', '==', true)
//   .get()
//   .then(() => {
//       // ...
//   });

// )



// WEBPACK FOOTER //
// ./src/models/firestore.js